import { NsCard } from 'components/common/ns-card/NsCard';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsList } from 'components/common/ns-list/NsList';
import { useNavigation } from 'hooks/useNavigation';
import { useIsExistingCustomer } from 'components/direct-sales/select-options/hooks/useIsExistingCustomer';
import { METER_TYPE_ERROR_CODES } from 'config/app-config';
import { TrackedCta } from 'components/direct-sales/select-options/components/TrackedCta';

type HomeMoveCardProps = {
  errors: {
    code: typeof METER_TYPE_ERROR_CODES[keyof typeof METER_TYPE_ERROR_CODES];
    keyword: 'Gas' | 'Electricity';
  }[];
  name: string;
};

export const HomeMoveCard = ({ errors, name }: HomeMoveCardProps) => {
  const { next, eventTypes } = useNavigation();
  const { isExistingCustomer } = useIsExistingCustomer({ errors });

  const handleGoNext = () => {
    next({ eventType: eventTypes.HOME_MOVE });
  };

  if (!isExistingCustomer) {
    return null;
  }

  return (
    <NsCard
      heading="Are you moving home?"
      action={
        <TrackedCta name={name}>
          <NsPrimaryCta onClick={handleGoNext} testId="homeMoveCtaTestId">
            Set up a new account
          </NsPrimaryCta>
        </TrackedCta>
      }
      decoration="home"
      testId="homeMoveCardTestId"
    >
      <NsList>
        {[
          'New to British Gas',
          'Received an Occupier letter',
          'Want us to supply your new home'
        ]}
      </NsList>
    </NsCard>
  );
};
